import { render } from "./gradeEditModal.vue?vue&type=template&id=5db593cf&scoped=true"
import script from "./gradeEditModal.vue?vue&type=script&lang=js"
export * from "./gradeEditModal.vue?vue&type=script&lang=js"

import "./gradeEditModal.vue?vue&type=style&index=0&id=5db593cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db593cf"]])

export default __exports__